import { type ReactNode, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';

interface AuthGuardProps {
  children: ReactNode;
}

/**
 * 로그인 필요 페이지 보호 래퍼.
 * - 비로그인 → 홈으로 리다이렉트
 * - 로그인 + 온보딩 미완료 → /onboarding 으로 리다이렉트
 */
export function AuthGuard({ children }: AuthGuardProps) {
  const { isLoggedIn, me } = useAuthStore();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    if (!isLoggedIn) {
      navigate('/', { replace: true });
    } else if (me && !me.onboardingDone && pathname !== '/onboarding') {
      navigate('/onboarding', { replace: true });
    }
  }, [isLoggedIn, me, pathname, navigate]);

  if (!isLoggedIn) return null;
  if (me && !me.onboardingDone && pathname !== '/onboarding') return null;
  return <>{children}</>;
}
